const diffArrays = (prev, next) => ({ remove: prev.filter(item => !next.includes(item)), add: next.filter(item => !prev.includes(item))});

export default diffArrays;